import { createFileRoute } from '@tanstack/react-router';
import { XeroCallbackFlow, type XeroCallbackSearch } from '../../../features/settings/components/XeroCallbackFlow';

/** Xero OAuth redirect target (BUILD_SPEC.md §12; services/api/src/modules/
 * xero/connection.ts's header comment) — `infra/lib/api-stack.ts` sets
 * `XERO_REDIRECT_URI` to `https://<cloudfront>/settings/xero/callback`
 * verbatim, so this route's path must match exactly. Nested under `settings/`
 * via TanStack Router's flat dot-notation (mirrors
 * stores-transfers/issues.$issueId.tsx's precedent: `xero.callback.tsx`
 * resolves to `/settings/xero/callback`, a sibling leaf of `xero.tsx` rather
 * than a child requiring its own layout file). Plan.md G26. */
export const Route = createFileRoute('/_authenticated/settings/xero/callback')({
  validateSearch: (search: Record<string, unknown>): XeroCallbackSearch => ({
    code: typeof search.code === 'string' ? search.code : undefined,
    state: typeof search.state === 'string' ? search.state : undefined,
    error: typeof search.error === 'string' ? search.error : undefined,
    error_description: typeof search.error_description === 'string' ? search.error_description : undefined,
  }),
  component: XeroCallbackRoute,
});

function XeroCallbackRoute() {
  const search = Route.useSearch();
  return <XeroCallbackFlow search={search} />;
}
